import { useUpdateUserSettings } from 'features/user';
import { useCallback } from 'react';
import { ID } from 'shared/types/id';

export const useToggleAllTasksSections = () => {
  const updateUserSettings = useUpdateUserSettings();

  return useCallback(
    (ids: ID[]) => {
      updateUserSettings({
        upcoming: {
          allTasks: {
            openedSections: ids,
          },
        },
      });
    },
    [updateUserSettings],
  );
};
